import { Box, Typography } from '@mui/material';
import { useGetVersion } from '../../hooks/use-get-version';

export const FooterVersion = () => {
  const [version] = useGetVersion();
  return (
    <Box
      sx={{
        mt: 4,
        width: '100%',
        position: 'relative',
        minHeight: 32,
        display: 'flex',
        alignItems: 'center',
      }}
    >
      <Typography
        variant="body2"
        sx={{
          position: 'absolute',
          left: '50%',
          transform: 'translateX(-50%)',
          width: 'max-content',
        }}
      >
        {`© ${new Date().getFullYear()} MyRealStat`}
      </Typography>
      <Box sx={{ flex: 1 }} />
      <Typography
        variant="body2"
        sx={{
          ml: 'auto',
          textAlign: 'right',
          minWidth: 'fit-content',
        }}
      >
        {`v${version}. Powered by Intellect Craft Consulting LLC`}
      </Typography>
    </Box>
  );
};
